import { SnacksState, SnacksAction, SnacksActionTypes } from './snacksTypes';

const initialState: SnacksState = {
  notifications: [],
};

export default function snacksReducer(
  state = initialState,
  action: SnacksAction,
): SnacksState {
  switch (action.type) {
    case SnacksActionTypes.ADD_SNACKBAR:
      if (!action.notification) {
        throw new Error();
      }
      return {
        ...state,
        notifications: [
          ...state.notifications,
          action.notification,
        ],
      };

    case SnacksActionTypes.CLEAR_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(({ key }) => {
          return key !== action.notificationKey;
        }),
      };

    default:
      return state;
  }
}
